import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { api } from '../api.js'
import Kopfzeile from '../Kopfzeile.jsx'
import Icon from '../Icon.jsx'
import { MONATSNAMEN, STATUSTEXT, alsDauer, euro } from '../format.js'

// Ein Monat, alle Mitarbeiter — der Einstieg für Vorgesetzte.
export default function Uebersicht() {
  const [parameter, setParameter] = useSearchParams()
  const jetzt = new Date()
  const jahr = Number(parameter.get('jahr')) || jetzt.getFullYear()
  const monat = Number(parameter.get('monat')) || jetzt.getMonth() + 1

  const [daten, setDaten] = useState(null)
  const [fehler, setFehler] = useState('')

  useEffect(() => {
    setFehler('')
    api(`/uebersicht/${jahr}/${monat}`)
      .then(setDaten)
      .catch((e) => setFehler(e.message))
  }, [jahr, monat])

  function verschiebe(schritte) {
    const roh = monat - 1 + schritte
    setParameter({
      jahr: String(jahr + Math.floor(roh / 12)),
      monat: String((((roh % 12) + 12) % 12) + 1),
    })
  }

  const offeneEinreichungen = daten?.zeilen.filter((z) => z.status === 'eingereicht').length ?? 0

  return (
    <main className="huelle">
      <Kopfzeile />

      <div className="monatsleiste">
        <button
          className="knopf knopf--geist knopf--symbol"
          type="button"
          onClick={() => verschiebe(-1)}
          title="Vorheriger Monat"
        >
          <Icon name="links" />
          <span className="nur-vorlesen">Vorheriger Monat</span>
        </button>
        <h2 className="monatstitel">
          {MONATSNAMEN[monat - 1]} {jahr}
        </h2>
        <button
          className="knopf knopf--geist knopf--symbol"
          type="button"
          onClick={() => verschiebe(1)}
          title="Nächster Monat"
        >
          <Icon name="rechts" />
          <span className="nur-vorlesen">Nächster Monat</span>
        </button>
      </div>

      {fehler && (
        <div className="meldung fehler" role="alert">
          <Icon name="warnung" groesse={18} />
          <span>{fehler}</span>
        </div>
      )}
      {!daten && !fehler && <p className="hinweis">Einen Moment …</p>}

      {daten && (
        <>
          {offeneEinreichungen > 0 && (
            <div className="meldung warnung">
              <Icon name="schloss" groesse={18} />
              <span>
                {offeneEinreichungen}{' '}
                {offeneEinreichungen === 1 ? 'Monatsblatt wartet' : 'Monatsblätter warten'} auf
                Freigabe.
              </span>
            </div>
          )}

          <section className="karte summenkarte">
            <div className="summenzeile summenzeile--gross">
              <span>Gesamt</span>
              <strong>{alsDauer(daten.zeilen.reduce((s, z) => s + z.summeMinuten, 0))}</strong>
            </div>
            <div className="summenzeile">
              <span className="gedaempft">Eingereicht</span>
              <span className="gedaempft">
                {offeneEinreichungen} von {daten.zeilen.length}
              </span>
            </div>
          </section>

          <section className="karte karte--liste">
            <h2>Mitarbeiter</h2>
            {daten.zeilen.length === 0 && (
              <div className="leerzustand">
                <Icon name="leute" groesse={32} strich={1.5} />
                <p>Noch keine Mitarbeiter angelegt.</p>
              </div>
            )}
            {daten.zeilen.map((zeile) => (
              <Link
                key={zeile.benutzerId}
                className="uebersichtszeile"
                to={`/?jahr=${jahr}&monat=${monat}&benutzer=${zeile.benutzerId}`}
              >
                <div className="uebersichtszeile__name">
                  <strong>{zeile.name}</strong>
                  <span className={`abzeichen abzeichen--${zeile.status}`}>
                    {STATUSTEXT[zeile.status]}
                  </span>
                </div>
                <div className="uebersichtszeile__zahlen">
                  <div className="uebersichtszeile__werte">
                    <span>{alsDauer(zeile.summeMinuten)}</span>
                    {zeile.verdienstCent !== null && (
                      <small className={zeile.ueberGrenze ? 'fehler' : 'gedaempft'}>
                        {euro(zeile.verdienstCent)}
                      </small>
                    )}
                  </div>
                  <Icon name="rechts" groesse={18} klasse="gedaempft" />
                </div>
              </Link>
            ))}
          </section>

          {daten.grenze && (
            <p className="hinweis">
              Hinterlegte Verdienstgrenze {jahr}: {euro(daten.grenze.betragCent)}
              {!daten.grenze.bestaetigt && ' (noch nicht bestätigt)'}
            </p>
          )}
        </>
      )}
    </main>
  )
}
